CoinsView = {};
CoinsView.CollectGlow0 = undefined;
CoinsView.CollectGlow4 = undefined;
CoinsView.CollectSprite0 = undefined;
CoinsView.CollectSprite4 = undefined;
CoinsView.emitter = undefined;
CoinsView.counterEmitter = undefined;
CoinsView.TempPulseObjects = [];
CoinsView.tempGemObject = [];
CoinsView.tempCoinEmitters = [];
CoinsView.canSkipCoins = false;
CoinsView.cashCoinBacking = undefined;
CoinsView.freeSpinsCounter = undefined;
CoinsView.currentFreeSpinsCount = 0;
CoinsView.PotsSavedForSkippFunction = []; //IMPORTANT FOR GOLDEN SPINS SKIPPING FUNCTIONALITY.
CoinsView.cashWin = true;
CoinsView.ready = false;
CoinsView.freeSpinsAwarded = 0;
CoinsView.HideGoldenBet = false;
CoinsView.symbolAnimator = undefined;
CoinsView._multiplierTextures = {};
CoinsView._sortedCollectableAwards = [];

CoinsView.create = function (json) {
  return new PIXI.Container();
};

CoinsView.onGameConfig = function () {};

CoinsView.getFilesRequired = function (json) {
  return [];
};

CoinsView.delay = (ms) => new Promise((res) => setTimeout(res, ms));

CoinsView.initialise = function () {
  Reflex.registerEventHandler("layoutChange", CoinsView.orientationChange.bind(CoinsView));
  CoinsView._multiplierTextures = {
    two: "Symbols/Kraken/Multipliers/x2.png",
    three: "Symbols/Kraken/Multipliers/x3.png",
    four: "Symbols/Kraken/Multipliers/x4.png",
    five: "Symbols/Kraken/Multipliers/x5.png",
  };

  CoinsView.symbolAnimator = resourceManager.get("slotContainer:SymbolAnimator");
  CoinsView.cashCoinBacking = resourceManager.get("cashCoinAmountContainer:cashCoinAmountBacking");
  //   CoinsView.cashCoinBacking.visible = true;
  CoinsView.cashCoinAmountText = resourceManager.get(
    "cashCoinAmountContainer:cashCoinAmountBacking:cashCoinAmountText"
  );
  CoinsView.ready = true;
};

CoinsView.doCashCoins = async () => {
  CoinsView.cashCoinsCompletePromise = new Promise((res) => {
    CoinsView.cashCoinsCompleteResolve = res;
  });

  CoinsView.coinIndex = 0;
  const gems = gameController.collectableAwards.awards
    .filter((e) => e.collectable.type === "Gem")
    .sort((a, b) => a.winAmount - b.winAmount);
  const coins = gameController.collectableAwards.awards.filter((e) => e.collectable.type === "Cash");
  const coinWins = gameController.collectableAwards.awards
    .filter((e) => e.collectable.type === "Cash")
    .reduce((total, coin) => total + coin.winAmount, 0);
  const coinsOrGems = coins.length > 0 || gems.length > 0;
  coinsOrGems && !gameController.hasRespun && !gameController.cyclingWins && gameController.dimNoneCollectableSymbols();

  if (!gameController.cyclingWins) {
    for (i = 0; i < gems.length; i++) {
      await Promise.all([CoinsView.animateCashCoins([gems[i]]), CoinsView.countUpWin(gems[i].winAmount)]);
    }
  }

  if (coinsOrGems && !gameController.cyclingWins) {
    // only emit particles if the coins are above stake
    const stake = resourceManager.getController("stakeController").CurrentStake;
    if (coinWins > stake) {
      gameController.emitCoins();
    }
  }

  if (coins.length > 0 && !gameController.cyclingWins) {
    CoinsView.countUpWin(coinWins);
    soundManager.play("coinWin");
    await CoinsView.animateCashCoins(coins);
  }

  if (gameController.cyclingWins) {
    await CoinsView.animateCashCoins(gameController.collectableAwards.awards);
  }
  CoinsView.cashCoinsCompleteResolve();
  CoinsView.tempGemObject = [];
  CoinsView.cleanUpEmmitersAndPulseObjects();

  if (!gameController.cyclingWins) {
    gameController.centreDevil.idleLoop();
  }
};

CoinsView.showCoinText = function (winnings) {
  const currentStake = resourceManager.getController("stakeController").getBaseStake();

  const obj = { amount: 0 };
  gameController.winningsCountup = gsap.to(obj, {
    duration: 0.9,
    amount: winnings,
    onUpdate: () => {
      gameData.winningsText.setText(obj.amount);
    },
    onComplete: () => {
      gameController.winningsCountup = undefined;
    },
  });
};

CoinsView.countUpWin = async function (winnings) {
  CoinsView.skipCountUpWin();
  return new Promise((resolve) => {
    gameController.cyclingWins ? resolve() : gameData.winningsMeter.countUp(winnings, 900, resolve);
  });
};

CoinsView.skipCountUpWin = function () {
  gameData.winningsMeter.cancelCountUp();
};

CoinsView.animateCashCoins = async function (coins) {
  return new Promise(async (resolve) => {
    const symbols = coins.map((coin) => {
      const reelIndex = helper.convertReelRowToIndex(coin.collectable.coord.reel, coin.collectable.coord.row);
      return {
        cell: { reel: reelIndex, row: 0 },
        symbolId: gameController.convertedReelResults[reelIndex][0],
      };
    });

    if (!gameController.cyclingWins && coins[0].collectable.type === "Gem") {
      if (gameController.potMeters.awardingPotPromise !== null) {
        await gameController.potMeters.awardingPotPromise;
      }
      gameController.potMeters.awardPot(coins[0].collectable.potName.toLowerCase());
    }

    this.symbolAnimator.animateSymbols(symbols, gameController.slotMachine, true, false, resolve);

    coins.forEach((coin) => {
      const reel = helper.convertReelRowToIndex(coin.collectable.coord.reel, coin.collectable.coord.row);
      const row = 0;

      const reelContainerPath = `slotContainer:reelContainer:reel${reel}`;
      const symbolPath = `${reelContainerPath}:symbol${row}:symbol:childContainer:multiplierTextOverlay:reel${reel}:row${row}`;

      const coinPosX = resourceManager.get(reelContainerPath).x;
      const coinPosY = resourceManager.get(reelContainerPath).y + 2;
      const textOverlay = resourceManager.get(symbolPath);

      const isGem = coin.collectable.type === "Gem";
      const isCash = coin.collectable.type === "Cash";

      if (isCash) {
        const text = resourceManager.createObject(
          "text",
          `TempCoinText${CoinsView.TempPulseObjects.length}`,
          "slotContainer:SymbolAnimator",
          {
            text: textOverlay.text,
            fontDefinition: "cashCoinOnFont",
            x: coinPosX,
            y: coinPosY,
            anchor: textOverlay.anchor,
            scale: textOverlay.scale.x,
          }
        );
        text.visible = true;
        CoinsView.TempPulseObjects.push({ text });

        gsap.to(text, {
          duration: 0.25,
          pixi: { scale: text.scale.x * 1.2 },
          ease: "power1.inOut",
          repeat: 3,
          yoyo: true,
        });
      } else if (isGem && gameController.multiModifier.isAwarded) {
        const textureMap = CoinsView._multiplierTextures;
        const multiplierTexture = {
          2: textureMap.two,
          3: textureMap.three,
          4: textureMap.four,
          5: textureMap.five,
        }[gameController.multiModifier.multiplier];

        const text = resourceManager.createObject(
          "sprite",
          `TempMultiplierSprite${CoinsView.tempGemObject.length}`,
          "slotContainer:SymbolAnimator",
          {
            fileName: multiplierTexture,
            x: coinPosX,
            y: coinPosY + 45,
            anchor: textOverlay.anchor,
          }
        );
        text.visible = true;
        CoinsView.tempGemObject.push({ text });

        gsap
          .fromTo(
            text.scale,
            { x: 0.5, y: 0.5 },
            {
              duration: 0.25,
              x: 0.7,
              y: 0.7,
              yoyo: true,
              repeat: 3,
            }
          )
          .then(() => {
            resourceManager.destroyObject(text.name);
          });
      }
    });
  });
};

CoinsView.fadeTextOut = function () {
  gsap.to(CoinsView.cashCoinBacking, {
    duration: 1,
    alpha: 0,
    onComplete: () => {
      gameController.centreDevil.idleLoop();
    },
  });
};

CoinsView.skipCoins = function (delay = 400) {
  spineSymbolAnimator.skip();
  CoinsView.canSkipCoins = false;
  let totalAmount = 0;
  gameController.cashCoinAmountText.visible = true;
  let callback = CoinsView.coinCashFinishCoinAmountAnimation.bind(CoinsView);
  gameController.canSkipWin = false;
  gameController.canSkipCoin = false;
  let amountOfFreeSpins = 0;

  if (gameController.inFreeSpins) {
    if (gameController.goldenSpinsMeterAtEnd - (GoldenSpins.spinsUsed + 1) === 0) {
      GoldenSpins.restoreCounter();
    }
    //if freespins and coins only
    if (GoldenSpins.goldenSpins.isAwarded && GoldenSpins.isGoldenSpin) {
      for (let index = 0; index < GoldenSpins.goldSpinsCompleted.length; index++) {
        totalAmount += GoldenSpins.goldSpinsCompleted[index].winAmount;
      }

      callback =
        GoldenSpins.goldenSpins.spins.length !== 0
          ? GoldenSpins.showIntro(GoldenSpins.start.bind(CoinsView))
          : CoinsView.coinCashFinishCoinAmountAnimation.bind(CoinsView);
      // if (
      //   GoldenSpins.currentCount === gameController.goldenSpinsMeterAtEnd &&
      //   GoldenSpins.goldenSpins.spins.length === 0
      // ) {
      //   musicManager.onGoldenSpinsEnd();
      // }
    } else if (GoldenSpins.goldenSpins.isAwarded) {
      // Add fs retriggers if any have been awarded
      if (gameController.spinTask.data.coinAwardsBeforeGoldenSpins !== undefined) {
        amountOfFreeSpins += gameController.spinTask.data.coinAwardsBeforeGoldenSpins.freeSpinsAwarded;
      }
      callback = GoldenSpins.showIntro(GoldenSpins.start.bind(CoinsView));
    }
    totalAmount += gameController.coinAwardsBeforeGoldenSpins.winAmount;

    totalAmount = totalAmount === undefined || totalAmount === 0 ? gameController.coinAwards.winAmount : totalAmount;
  } else {
    //if basegame and coins only
    totalAmount = gameController.coinAwards.winAmount;

    // Update fs to counter if feature is starting
    if (gameController.spinTask.data.coinAwards.freeSpinsAwarded !== undefined) {
      amountOfFreeSpins = gameController.spinTask.data.coinAwards.freeSpinsAwarded;
    }
  }

  gameController.previousWinnings = totalAmount;
  gameController.coinWinnings = totalAmount;

  gameController.cashCoinAmountText.alpha = 1;
  gameController.cashCoinAmountText.visible = true;
  CoinsView.cashCoinBacking.alpha = 1;
  CoinsView.cashCoinBacking.visible = true;

  amountOfFreeSpins = amountOfFreeSpins - CoinsView.freeSpinsAwarded;
  if (amountOfFreeSpins > 0) {
    CoinsView.freeSpinsAwarded = 0;
    if (gameController.inFreeSpins) {
      if (gameController.freeSpinsController._freespinsCount + amountOfFreeSpins !== CoinsView.currentFreeSpinsCount) {
        CoinsView.currentFreeSpinsCount += amountOfFreeSpins;
        gameController.freeSpinsController._freespinsCount = CoinsView.currentFreeSpinsCount;
        gameController.freeSpinsController._spinsLeft += amountOfFreeSpins;
      }
      CoinsView.freeSpinsCounterValue.setTranslationParameters(
        gameController.freeSpinsController._freespinsCount - gameController.freeSpinsController._spinsLeft,
        CoinsView.currentFreeSpinsCount
      );
    } else {
      CoinsView.freeSpinsCounter.visible = true;
      gsap.to(CoinsView.freeSpinsCounter, {
        duration: 0.25,
        ease: "linear",
        alpha: 1,
      });
      CoinsView.HideGoldenBet = true;
      resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").visible = false;
      CoinsView.currentFreeSpinsCount = amountOfFreeSpins;
      CoinsView.freeSpinsCounterValue.setTranslationParameters(
        gameController.freeSpinsController._freespinsCount - gameController.freeSpinsController._spinsLeft,
        CoinsView.currentFreeSpinsCount
      );
    }
  }

  gameController.cashCoinAmountText.setText(
    gdk.formatCurrency(totalAmount, gameController.useCurrency()),
    gameController.useCurrency()
  );

  timerManager.addTimer(delay, undefined, callback);
};

CoinsView.sortArrayByCoord = function (coins) {
  return coins.sort((a, b) => {
    if (a.collectCoord.reel < b.collectCoord.reel) {
      return -1;
    }
    if (a.collectCoord.reel > b.collectCoord.reel) {
      return 1;
    }
    if (a.coin.coord.reel < b.coin.coord.reel) {
      return -1;
    }
    if (a.coin.coord.reel > b.coin.coord.reel) {
      return 1;
    }
    if (a.coin.coord.row < b.coin.coord.row) {
      return -1;
    }
    if (a.coin.coord.row > b.coin.coord.row) {
      return 1;
    }
    return 0;
  });
};

CoinsView.pulseAllCoins = function (addToCounter) {
  // soundManager.play("collectAnimate");
  gameController.checkBackgroundThemeLevels();
  if (addToCounter) {
    CoinsView.canSkipCoins = false;
    CoinsView.addToCounter();
  }
  let cashCoinsArray = [];
  let allCoinsArray = [];
  gameController.coins.forEach((coin, index) => {
    if (coin.type !== "Pot") {
      const symData = helper.getCoinSymbolsFromReelPosition(coin.coord.reel, coin.coord.row);
      allCoinsArray.push(symData);
      if (coin.type === "Cash") {
        cashCoinsArray.push(symData);
      }
    }
    if (coin.type === "Pot") {
      PrizePots.PulsePot(coin);
    }

    let collectCoordArray = CoinsView.getCollectCoords();
    if (collectCoordArray.length > 0) {
      collectCoordArray.forEach((collect) => {
        CoinsView.coinCashTriggerCollectGlow(collect);
      });
    }
  });
  if (cashCoinsArray.length > 0) {
    CoinsView.pulseAllCoinSymbol(cashCoinsArray);
  }
  if (allCoinsArray.length > 0) {
    spineSymbolAnimator.animate(allCoinsArray, CoinsView.cleanUpEmmitersAndPulseObjects.bind(CoinsView));
  }
};

CoinsView.addToCounter = function () {
  gameController.coinCollectCurrent += gameController.coinAwards.coins.length;
  CoinsView.collectCoinsForCounter();
};

CoinsView.scaleAndUpdateCounter = async function () {
  let stakeController = resourceManager.getController("stakeController");
  let coinCounterContainer = resourceManager.get("slotContainer:postReels:CoinCounterContainer:coinCollectMeterFont");
  let scale = coinCounterContainer.scale;
  let duration = CloverRespins.respinData.isAwarded ? 1 : 0.6;
  let delay = CloverRespins.respinData.isAwarded ? 0.5 : 0;
  gsap
    .timeline()
    .to(coinCounterContainer.scale, {
      duration: duration,
      ease: "linear",
      x: scale._x * 1.3,
      y: scale._y * 1.3,
      onComplete: () => {
        if (!CloverRespins.respinData.isAwarded) {
          // soundManager.play("coinBurst");
          CoinsView.counterEmitter.particleEmitter.emit = true;
          CoinsView.counterEmitter.visible = true;
          if (!gameData.slotConfig.inReplayMode) {
            gameController.updateCounterState(stakeController.getCurrentStake());
          }
        } else {
          // soundManager.play("cloverWon");
          CoinsView.counterEmitter.particleEmitter.emit = true;
          CoinsView.counterEmitter.visible = true;
        }
        gameController.updateCounters();
      },
    })
    .to(coinCounterContainer.scale, {
      delay: delay,
      duration: 0.4,
      ease: "linear",
      x: scale._x,
      y: scale._y,
      onComplete: () => {
        CoinsView.counterComplete();
        // CoinsView.animateCashCoins();
      },
    });
};

CoinsView.counterComplete = async function () {
  await CoinsView.delay(1000);
  CoinsView.animateCashCoins();
};

CoinsView.createTempEmitter = function () {
  const emitter = particleManager.createEmitter(
    "cashcoinParticle",
    "slotContainer:particlesContainerFront",
    0,
    0,
    false
  );
  emitter.particleEmitter.emit = false;
  emitter.visible = false;
  return emitter;
};

CoinsView.collectCoinsForCounter = async function () {
  coin = gameController.coinAwards.coins[gameController.arrCount];
  numOfCoins = gameController.coinAwards.coins.length;

  gameController.coinAwards.coins.forEach((coin, index) => {
    const emitter = CoinsView.createTempEmitter();
    CoinsView.tempCoinEmitters.push(emitter);
    const collectCoord = CoinsView.checkSymbolIsOnReelsAndHasCollector(coin);
    const pos = helper.getCoinSymbolsPos(coin.coin.coord.reel, coin.coin.coord.row);
    if (pos !== undefined && collectCoord !== undefined) {
      CoinsView.coinCashVfxMoveToCollectCounter(pos, emitter);
      CoinsView.coinCashTriggerCollectGlow(collectCoord);
    }
  });
  await CoinsView.delay(500);
  CoinsView.scaleAndUpdateCounter();
};

CoinsView.getCollectCoords = function () {
  let collects = [];
  let collectID = 54;
  for (let row = 0; row < 3; row++) {
    if (gameController.spinTask.data.resultPanel.reelList[0].symbols[row].value === collectID) {
      collects.push({ reel: 0, row: row });
    }
    if (gameController.spinTask.data.resultPanel.reelList[4].symbols[row].value === collectID) {
      collects.push({ reel: 4, row: row });
    }
  }
  return collects;
};

CoinsView.updateWinnings = function (amt) {
  if (!CoinsView.canSkipCoins) {
    gameController.coinWinnings = gameController.coinWinnings + amt;
    let coinLength;
    let winAmount;
    let self = this;

    let coin;
    let numOfCoins;

    if (gameController.inFreeSpins) {
      let coinArray =
        GoldenSpins.goldenSpins.isAwarded && GoldenSpins.isGoldenSpin
          ? GoldenSpins.currentSpin.coinAwards
          : gameController.coinAwardsBeforeGoldenSpins.coins;
      coin = coinArray[gameController.arrCount];
      numOfCoins = coinArray.length;
    } else {
      coin = gameController.coinAwards.coins[gameController.arrCount];
      numOfCoins = gameController.coinAwards.coins.length;
    }

    const collectCoord = self.checkSymbolIsOnReelsAndHasCollector(coin);

    if (collectCoord === undefined) {
      if (gameController.arrCount >= numOfCoins) {
        CoinsView.coinCashFinishCoinAmountAnimation();
      }
      if (gameController.arrCount < coinLength) {
        if (gameController.inFreeSpins) {
          winAmount = gameController.coinAwardsBeforeGoldenSpins.coins[gameController.arrCount].winAmount;
        } else {
          winAmount = gameController.coinAwards.coins[gameController.arrCount].winAmount;
        }

        self.animateCashCoins();
      }
    } else {
      const pos = helper.getCoinSymbolsPos(coin.coin.coord.reel, coin.coin.coord.row);

      if (coin.coin.type === "Bonus" && pos !== undefined) {
        self.pulsePotSymbol(coin.coin);
        CoinsView.freeSpinsCounter.visible = true;
        CoinsView.HideGoldenBet = true;
        resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").visible = false;
        if (CoinsView.freeSpinsCounter.alpha !== 1) {
          CoinsView.revealFreeSpins(pos, coin.coin.freeSpinsCount);
        } else {
          CoinsView.coinCashVfxMoveToFreeSpinsCounter(pos, coin.coin.freeSpinsCount);
        }
      } else if (pos !== undefined) {
        self.coinCashVfxMoveToCounter(pos, gameController.cashCoinAmountText);
        self.coinCashTriggerCollectGlow(collectCoord);
      }

      if (coin.coin.type === "Cash") {
        self.pulseCoinSymbol(coin.coin);
      }

      if (coin.coin.type === "Pot") {
        PrizePots.PulsePot(coin.coin);
      }

      if (coin.coin.type !== "Bonus" || !gameController.inFreeSpins) {
        self.countUpWinningsTween(
          gameController.cashCoinAmountText,
          gameController.previousWinnings,
          gameController.coinWinnings,
          function () {
            gameController.arrCount++;

            if (gameController.inFreeSpins) {
              coinLength = gameController.coinAwardsBeforeGoldenSpins.coins.length;
            } else {
              coinLength = gameController.coinAwards.coins.length;
            }
            if (gameController.arrCount < coinLength) {
              self.animateCashCoins();
            } else {
              if (gameController.inFreeSpins && gameController.goldenSpins.isAwarded) {
                //if free spins and gold spins awarded
                if (GoldenSpins.goldenSpins.spins.length > 0) {
                  GoldenSpins.showIntro(GoldenSpins.start.bind(CoinsView));
                  // GoldenSpins.start();
                } else {
                  // musicManager.onGoldenSpinsEnd();
                  GoldenSpins.isGoldenSpin = false;
                  GoldenSpins.restoreCounter();

                  CoinsView.coinCashFinishCoinAmountAnimation();
                }
              } else {
                if (gameController.inFreeSpins) {
                  GoldenSpins.restoreCounter();
                }
                CoinsView.coinCashFinishCoinAmountAnimation();
              }
            }
          }
        );
        gameController.previousWinnings = gameController.coinWinnings;
      } else {
        timerManager.addTimeout(1000, CoinsView.onFreespinsRetrigger.bind(CoinsView, coin.coin.freeSpinsCount));
      }
    }
  } else {
    CoinsView.canSkipCoins = false;
    CoinsView.skipCoins();
  }
};

CoinsView.onFreespinsRetrigger = function (numberOfFreespins) {
  gameController.canSkipWin = false;

  gameController.freeSpinsController._retriggerPopup.visible = true;
  gameController.freeSpinsController._retriggerPopup.alpha = 0;
  gameController.dimNoneWinningSymbolsBySymbolGroup([]);

  // soundManager.play("hbc_whoosh_v1");

  gameController.freeSpinsController._freespinsRetriggerValue.setText("+" + numberOfFreespins);

  const self = this;
  timerManager.addTimer(
    1000,
    function (progress) {
      gameController.freeSpinsController._retriggerPopup.alpha = progress;
    },
    function () {
      gameController.freeSpinsController._retriggerPopup.alpha = 1;

      CoinsView.displayRetriggerPanel();
    }
  );

  gameController.freeSpinsController._spinsLeft += numberOfFreespins;
  gameController.freeSpinsController._freespinsCount += numberOfFreespins;
};

CoinsView.displayRetriggerPanel = function () {
  let pos = gameController.freeSpinsController._retriggerPopup.position;
  gsap
    .timeline()
    .to(gameController.freeSpinsController._retriggerPopup.position, {
      duration: 0.5,
      ease: "linear",
      y: pos._y + 5,
    })
    .to(gameController.freeSpinsController._retriggerPopup.position, {
      duration: 0.5,
      ease: "linear",
      y: pos._y,
    })
    .to(gameController.freeSpinsController._retriggerPopup.position, {
      duration: 0.5,
      ease: "linear",
      y: pos._y + 5,
    })
    .to(gameController.freeSpinsController._retriggerPopup.position, {
      duration: 0.5,
      ease: "linear",
      y: pos._y,
    })
    .to(gameController.freeSpinsController._retriggerPopup.position, {
      duration: 0.5,
      ease: "linear",
      y: pos._y + 5,
    })
    .to(gameController.freeSpinsController._retriggerPopup.position, {
      duration: 0.5,
      ease: "linear",
      y: pos._y,
      onComplete: () => {
        CoinsView.hideRetriggerPanel();
      },
    });
};

CoinsView.hideRetriggerPanel = function () {
  const self = this;
  gameController.dimNoneWinningSymbolsBySymbolGroup(helper.getCollectSymbolsReelsInfo());
  timerManager.addTimer(
    1000,
    function (progress) {
      gameController.freeSpinsController._retriggerPopup.alpha = 1 - progress;
    },
    function () {
      gameController.canSkipWin = true;

      gameController.freeSpinsController._retriggerPopup.alpha = 0;
      self.countUpWinningsTween(
        gameController.cashCoinAmountText,
        gameController.previousWinnings,
        gameController.coinWinnings,
        function () {
          gameController.arrCount++;

          if (gameController.inFreeSpins) {
            coinLength = gameController.coinAwardsBeforeGoldenSpins.coins.length;
          } else {
            coinLength = gameController.coinAwards.coins.length;
          }
          if (gameController.arrCount < coinLength) {
            self.animateCashCoins();
          } else {
            if (gameController.inFreeSpins && gameController.goldenSpins.isAwarded) {
              //if free spins and gold spins awarded
              if (GoldenSpins.goldenSpins.spins.length > 0) {
                GoldenSpins.showIntro(GoldenSpins.start.bind(CoinsView));
                // GoldenSpins.start();
              } else {
                // musicManager.onGoldenSpinsEnd();
                GoldenSpins.isGoldenSpin = false;
                GoldenSpins.restoreCounter();

                CoinsView.coinCashFinishCoinAmountAnimation();
              }
            } else {
              if (gameController.inFreeSpins) {
                GoldenSpins.restoreCounter();
              }
              CoinsView.coinCashFinishCoinAmountAnimation();
            }
          }
        }
      );
      gameController.previousWinnings = gameController.coinWinnings;
    }
  );
};

CoinsView.revealFreeSpins = function (symbolPos, freeSpinsAwarded) {
  CoinsView.freeSpinsCounter.visible = true;
  CoinsView.freeSpinsCounterValue.visible = false;
  gsap
    .timeline()
    .call(() => {
      CoinsView.freeSpinsCounter.alpha = 0;
      CoinsView.showBetOptions(false);
    })
    .to(CoinsView.freeSpinsCounter, {
      duration: 0.25,
      ease: "linear",
      alpha: 1,
      onComplete: () => {
        CoinsView.TriggerVfxMoveToFreeSpinsCounterAfterDelay(symbolPos, freeSpinsAwarded);
      },
    });
};

CoinsView.TriggerVfxMoveToFreeSpinsCounterAfterDelay = function (symbolPos, freeSpinsAwarded) {
  timerManager.addTimeout(250, function () {
    CoinsView.coinCashVfxMoveToFreeSpinsCounter(symbolPos, freeSpinsAwarded);
  });
};

CoinsView.processPots = function () {
  let coinLength;
  let winAmount;
  let self = this;

  let coin;
  let numOfCoins;
  let potArray = gameController.coinAwardsAfterGoldenSpins.coins;
  numOfCoins = potArray.length;
  coin = potArray.shift();

  gameController.coinWinnings = gameController.coinWinnings + coin.winAmount;
  const collectCoord = coin.collectCoord;

  const pos = helper.getCoinSymbolsPos(coin.coin.coord.reel, coin.coin.coord.row);

  if (pos !== undefined) {
    self.coinCashVfxMoveToCounter(pos, gameController.cashCoinAmountText);
    self.coinCashTriggerCollectGlow(collectCoord);
  }

  PrizePots.PulsePot(coin.coin);
  self.countUpWinningsTween(
    gameController.cashCoinAmountText,
    gameController.previousWinnings,
    gameController.coinWinnings,
    function () {
      gameController.arrCount++;

      if (gameController.inFreeSpins) {
        coinLength = gameController.coinAwardsBeforeGoldenSpins.coins.length;
      } else {
        coinLength = gameController.coinAwards.coins.length;
      }
      if (gameController.arrCount < coinLength) {
        self.animateCashCoins();
      } else {
        if (gameController.inFreeSpins && gameController.goldenSpins.isAwarded) {
          //if free spins and gold spins awarded
          if (GoldenSpins.goldenSpins.spins.length > 0) {
            // GoldenSpins.start();
            GoldenSpins.showIntro(GoldenSpins.start.bind(CoinsView));
          } else {
            GoldenSpins.isGoldenSpin = false;
            CoinsView.coinCashFinishCoinAmountAnimation();
          }
        } else {
          CoinsView.coinCashFinishCoinAmountAnimation();
        }
      }
    }
  );
  //gameController.previousWinnings = gameController.coinWinnings;
};

CoinsView.checkSymbolIsOnReelsAndHasCollector = function (coin) {
  for (let index = 0; index < gameController.coins.length; index++) {
    const compareCoin = gameController.coins[index];
    if (coin.coin.coord.reel === compareCoin.coord.reel && coin.coin.coord.row === compareCoin.coord.row) {
      return coin.collectCoord;
    }
  }
  return undefined;
};

CoinsView.pulsePotSymbol = function (coin) {
  const row = coin.coord.row;
  const reel = coin.coord.reel;
  const symbol = helper.getCoinSymbolsFromReelPosition(reel, row);

  spineSymbolAnimator.animate([symbol]);
};

CoinsView.pulseCoinSymbol = function (coin) {
  const row = coin.coord.row;
  const reel = coin.coord.reel;
  const symbol = helper.getCoinSymbolsFromReelPosition(reel, row);

  const coinTextOverlay = resourceManager.get(
    `slotContainer:reelContainer:reel${reel}:symbol${row}:symbol:childContainer:multiplierTextOverlay:reel${reel}:row${row}`
  );

  const coinTextOverlayPos = helper.getCenterSymbolsPos(reel, row);

  spineSymbolAnimator.animate([symbol], CoinsView.cleanUpEmmitersAndPulseObjects.bind(CoinsView));

  const text = resourceManager.createObject(
    "text",
    `TempCoinText${CoinsView.TempPulseObjects.length}`,
    "slotContainer:postReels:PrizePotsContainer",
    {
      text: coinTextOverlay.text,
      fontDefinition: "multiplierFont",
      x: coinTextOverlayPos.x,
      y: coinTextOverlayPos.y,
      maxWidth: coinTextOverlay.maxWidthDisplay,
      anchor: coinTextOverlay.anchor,
    }
  );
  text.visible = true;
  coinTextOverlay.alpha = 0;
  coinTextOverlay.visible = false;

  for (let index = 0; index < CoinsView.TempPulseObjects.length; index++) {
    const otherClone = CoinsView.TempPulseObjects[index].text;
    otherClone.alpha = 0;
  }

  CoinsView.TempPulseObjects.push({ text: text, textOverlay: coinTextOverlayPos });

  gsap
    .timeline()
    .to(text.position, {
      duration: 0.25,
      ease: "linear",
      y: coinTextOverlayPos.y - 15,
    })
    .to(text.position, {
      duration: 0.25,
      ease: "bounce.in",
      y: coinTextOverlayPos.y,
      onComplete: () => {
        coinTextOverlay.alpha = 1;
        coinTextOverlay.visible = true;
      },
    })
    .to(text.position, {
      duration: 0.5,
      ease: "linear",
      y: coinTextOverlayPos.y,
    });
};

CoinsView.pulseAllCoinSymbol = function (coins) {
  for (let index = 0; index < coins.length; index++) {
    const coin = coins[index];

    const row = coin.cell.row;
    const reel = coin.cell.reel;

    const coinTextOverlay = resourceManager.get(
      `slotContainer:reelContainer:reel${reel}:symbol${row}:symbol:childContainer:multiplierTextOverlay:reel${reel}:row${row}`
    );

    const coinTextOverlayPos = helper.getCenterSymbolsPos(reel, row);

    const text = resourceManager.createObject(
      "text",
      `TempCoinText${CoinsView.TempPulseObjects.length}`,
      "slotContainer:postReels:PrizePotsContainer",
      {
        text: coinTextOverlay.text,
        fontDefinition: "multiplierFont",
        x: coinTextOverlayPos.x,
        y: coinTextOverlayPos.y,
        maxWidth: coinTextOverlay.maxWidthDisplay,
        anchor: coinTextOverlay.anchor,
        textOverlay: coinTextOverlay,
      }
    );
    text.visible = true;
    coinTextOverlay.alpha = 0;

    CoinsView.TempPulseObjects.push({
      text: text,
      textOverlay: coinTextOverlayPos,
    });

    gsap
      .timeline()
      .to(text.position, {
        duration: 0.25,
        ease: "linear",
        y: coinTextOverlayPos.y - 15,
      })
      .to(text.position, {
        duration: 0.25,
        ease: "bounce.in",
        y: coinTextOverlayPos.y,
        onComplete: () => {
          coinTextOverlay.alpha = 1;
        },
      })
      .to(text.position, {
        duration: 0.5,
        ease: "linear",
        y: coinTextOverlayPos.y,
      });
  }
};

CoinsView.coinCashTriggerCollectGlow = function (collectCoord) {
  const self = this;
  const newPos = helper.getCenterSymbolsPos(collectCoord.reel, collectCoord.row);
  collectSprite = collectCoord.reel === 0 ? CoinsView.CollectSprite0 : CoinsView.CollectSprite4;
  collectGlow = collectCoord.reel === 0 ? CoinsView.CollectGlow0 : CoinsView.CollectGlow4;

  collectSprite.position.setX(newPos.x);
  collectSprite.position.setY(newPos.y);
  collectSprite.visible = true;

  gsap
    .timeline()
    .to(collectSprite.scale, {
      duration: 0.25,
      ease: "linear",
      x: 1.2,
      y: 1.2,
    })
    .to(collectSprite.scale, {
      duration: 0.25,
      ease: "linear",
      x: 1,
      y: 1,
    });
  gsap
    .timeline()
    .call(() => {
      collectGlow.alpha = 0;
      collectGlow.visible = true;
    })
    .to(collectGlow, {
      duration: 0.25,
      ease: "linear",
      alpha: 0.8,
    })
    .to(collectGlow, {
      duration: 0.25,
      ease: "linear",
      alpha: 0,
    });
};

CoinsView.coinCashVfxMoveToCounter = function (symbolPos, graphicObj) {
  CoinsView.emitter.particleEmitter.spawnPos = symbolPos;

  const duration = 0.5;
  const self = this;

  gsap
    .timeline()
    .call(() => {
      self.emitter.particleEmitter.emit = true;
      self.emitter.visible = true;
      // soundManager.play("coinWhoosh");
    })
    .to(self.emitter.particleEmitter.spawnPos, {
      duration,
      ease: "power3.in",
      y: CoinsView.cashCoinBacking.y,
    })
    .to(
      self.emitter.particleEmitter.spawnPos,
      {
        duration,
        ease: "linear",
        x: CoinsView.cashCoinBacking.x,
        onComplete: () => {
          self.emitter.particleEmitter.emit = false;
          self.emitter.visible = false;
          CoinsView.bounceWinnings(graphicObj);
        },
      },
      "<"
    );
};

CoinsView.coinCashVfxMoveToFreeSpinsCounter = function (symbolPos, freeSpinsAwarded) {
  CoinsView.emitter.particleEmitter.spawnPos = symbolPos;
  CoinsView.currentFreeSpinsCount += freeSpinsAwarded;
  CoinsView.freeSpinsAwarded += freeSpinsAwarded;
  const duration = 0.5;
  const self = this;

  gsap
    .timeline()
    .call(() => {
      self.emitter.particleEmitter.emit = true;
      self.emitter.visible = true;
      // soundManager.play("coinWhoosh");
    })
    .to(self.emitter.particleEmitter.spawnPos, {
      duration,
      ease: "power3.in",
      y: CoinsView.freeSpinsCounter.y,
    })
    .to(
      self.emitter.particleEmitter.spawnPos,
      {
        duration,
        ease: "linear",
        x: CoinsView.freeSpinsCounter.x,
        onComplete: () => {
          self.emitter.particleEmitter.emit = false;
          self.emitter.visible = false;
          CoinsView.freeSpinsCounter.visible = true;
          CoinsView.freeSpinsCounterValue.visible = true;
          CoinsView.freeSpinsCounterValue.setTranslationParameters(
            gameController.freeSpinsController._freespinsCount - gameController.freeSpinsController._spinsLeft,
            CoinsView.currentFreeSpinsCount
          );
          CoinsView.bounceWinnings(CoinsView.freeSpinsCounterValue);
        },
      },
      "<"
    );
};

CoinsView.showBetOptions = function (visible) {
  let buyABonus = resourceManager.get("buttonContainer:buttonBar:buyBonusButton");

  let start = visible ? 0 : 1;
  let target = visible ? 1 : 0;

  gsap.fromTo(
    buyABonus,
    {
      visible: true,
      alpha: start,
    },
    {
      duration: 0.25,
      alpha: target,
    }
  );
};

CoinsView.coinCashVfxMoveToCollectCounter = function (symbolPos, emitter) {
  const amountText = resourceManager.get("slotContainer:postReels:CoinCounterContainer:coinCollectMeterFont");
  emitter.particleEmitter.spawnPos = symbolPos;

  const duration = 0.5;
  const self = this;

  gsap
    .timeline()
    .call(() => {
      emitter.particleEmitter.emit = true;
      emitter.visible = true;
      // soundManager.play("coinWhoosh");
    })
    .to(emitter.particleEmitter.spawnPos, {
      duration,
      ease: "power3.in",
      y: amountText.y,
    })
    .to(
      emitter.particleEmitter.spawnPos,
      {
        duration,
        ease: "linear",
        x: amountText.x,
        onComplete: () => {
          emitter.particleEmitter.emit = false;
          emitter.visible = false;
        },
      },
      "<"
    );
};

CoinsView.countUpWinningsTween = function (graphicObj, countFrom, countTo, cb) {
  var counter = { var: countFrom };

  //   if (!CoinsView.cashCoinBacking.visible && CoinsView.cashWin) {
  //     soundManager.play("boardAppear");
  //   }
  CoinsView.cashCoinBacking.visible = true;
  CoinsView.cashCoinBacking.alpha = 1;

  //   let numOfCoins;

  //   if (gameController.inFreeSpins) {
  //     numOfCoins = gameController.coinAwardsBeforeGoldenSpins.coins.length;
  //   } else {
  //     numOfCoins = gameController.coinAwards.coins.length;
  //   }

  let countUpTween = gsap.to(counter, 1, {
    var: countTo,
    duration: 0.5,
    ease: Circ.easeOut,
    onStart: () => {
      if (!musicManager.isSoundPlaying("winCountUp")) soundManager.play("winCountUp");
      // graphicObj.visible = true;
    },
    onUpdate: () => {
      graphicObj.setText(gdk.formatCurrency(counter.var, gameController.useCurrency()), gameController.useCurrency());
    },
    onComplete: () => {
      if (cb) {
        cb();
      }
    },
  });
};

CoinsView.bounceWinnings = function (graphicObj) {
  const orginalGraphicObjPos = graphicObj.y;

  gsap.to(graphicObj, {
    duration: 0.2,
    ease: "bounce.in",
    y: graphicObj.y - 25,
    onComplete: () => {
      gsap.to(graphicObj, {
        duration: 0.2,
        ease: "bounce.out",
        y: orginalGraphicObjPos,
      });
    },
  });
};

CoinsView.coinCashFinishCoinAmountAnimation = function () {
  gsap.to(CoinsView.cashCoinBacking, {
    duration: 1,
    alpha: 0,
    onComplete: () => {
      const stake = resourceManager.getController("stakeController").CurrentStake;
      const bonusFound = gameController.coins.some((coin) => coin.type === "Bonus");
      // if (gameController.totalWinnings <= stake && !bonusFound && !gameController.inFreeSpins) {
      //   soundManager.play("addToCredit");
      // }
      CoinsView.cashCoinBacking.visible = false;
      CoinsView.cashCoinBacking.alpha = 1;
      CoinsView.CollectSprite0.visible = false;
      CoinsView.CollectSprite4.visible = false;
      CoinsView.cleanUp();
      gameController.centreDevil.idleLoop();
      //gameController.cashCoinsAnimationsComplete = true;
      // if (gameController.cloverRespinsComplete) {
      //   musicManager.onCloverRespinsEnd();
      // }
    },
  });
};

CoinsView.cleanUpEmmitersAndPulseObjects = function () {
  for (let index = 0; index < CoinsView.TempPulseObjects.length; index++) {
    const tempObj = CoinsView.TempPulseObjects[index].text;
    resourceManager.destroyObject(tempObj.name);
  }
  CoinsView.TempPulseObjects = [];
  for (let index = 0; index < CoinsView.tempCoinEmitters.length; index++) {
    const tempObj = CoinsView.tempCoinEmitters[index];
    resourceManager.destroyObject(tempObj.name);
  }
  CoinsView.tempCoinEmitters = [];
};

CoinsView.cleanUp = function () {
  for (let index = 0; index < CoinsView.TempPulseObjects.length; index++) {
    const tempObj = CoinsView.TempPulseObjects[index].text;
    resourceManager.destroyObject(tempObj.name);
  }
  CoinsView.TempPulseObjects = [];
  for (let index = 0; index < CoinsView.tempCoinEmitters.length; index++) {
    const tempObj = CoinsView.tempCoinEmitters[index];
    resourceManager.destroyObject(tempObj.name);
  }
  CoinsView.tempCoinEmitters = [];
  CoinsView.currentFreeSpinsCount = 0;
  CoinsView.freeSpinsAwarded = 0;
};

CoinsView.orientationChange = function () {
  // if (CoinsView.ready) {
  //   let counter = resourceManager.get("slotContainer:postReels:CoinCounterContainer:coinCollectMeterFont");
  //   CoinsView.counterEmitter.x = counter.x;
  //   CoinsView.counterEmitter.y = counter.y;
  //   if (gameData.reelsSpinning <= 0) {
  //     let collectCoord;
  //     timerManager.addTimer(5, () => {
  //       const hideInCoins =
  //         layoutController.getCurrentLayout() === "landscape_mobile" && CoinsView.HideGoldenBet ? true : false;
  //       if (gameData.encoreEnabled && hideInCoins) {
  //         resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").luckyBetAnim.visible = false;
  //       } else if (gameData.encoreEnabled && !gameController.inFreeSpins) {
  //         resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").luckyBetAnim.visible = true;
  //       }
  //       if (gameController.inFreeSpins) {
  //         //if freespins and coins only
  //         if (
  //           GoldenSpins.goldenSpins &&
  //           GoldenSpins.goldenSpins.isAwarded &&
  //           GoldenSpins.isGoldenSpin &&
  //           GoldenSpins.currentSpin.coinAwards.length > gameController.arrCount
  //         ) {
  //           collectCoord = GoldenSpins.currentSpin.coinAwards[gameController.arrCount].collectCoord;
  //         } else if (
  //           gameController.coinAwardsBeforeGoldenSpins &&
  //           gameController.coinAwardsBeforeGoldenSpins.coins.length > gameController.arrCount
  //         ) {
  //           collectCoord = gameController.coinAwardsBeforeGoldenSpins.coins[gameController.arrCount].collectCoord;
  //         }
  //       } else if (gameController.coinAwards !== undefined) {
  //         //if basegame and coins only
  //         if (gameController.coinAwards.coins.length > gameController.arrCount) {
  //           collectCoord = gameController.coinAwards.coins[gameController.arrCount].collectCoord;
  //         }
  //       }
  //       if (collectCoord !== undefined) {
  //         const newPos = helper.getCenterSymbolsPos(collectCoord.reel, collectCoord.row);
  //         const collectSprite = collectCoord.reel === 0 ? CoinsView.CollectSprite0 : CoinsView.CollectSprite4;
  //         const otherCollectSprite = collectCoord.reel === 0 ? CoinsView.CollectSprite4 : CoinsView.CollectSprite0;
  //         collectSprite.position.setX(newPos.x);
  //         collectSprite.position.setY(newPos.y);
  //         collectSprite.visible = true;
  //         otherCollectSprite.visible = false;
  //       } else {
  //         CoinsView.CollectSprite0.visible = false;
  //         CoinsView.CollectSprite4.visible = false;
  //       }
  //       for (let index = 0; index < CoinsView.TempPulseObjects.length; index++) {
  //         const tempCoinText = CoinsView.TempPulseObjects[index];
  //         tempCoinText.text.position.setX(tempCoinText.textOverlay.x);
  //         tempCoinText.text.position.setY(tempCoinText.textOverlay.y);
  //       }
  //     });
  //   } else {
  //     CoinsView.CollectSprite0.visible = false;
  //     CoinsView.CollectSprite4.visible = false;
  //   }
  // }
};

resourceManager.registerObjectType("CoinsView", CoinsView.create, CoinsView.initialise, CoinsView.getFilesRequired);
